import api from "@/services/utils/apiInstance.ts";
import type { CustomAxiosRequestConfig } from "@/types/services/utils/axios.type.ts";

import type {
  ForgotPasswordRequest,
  InitializePasswordRequest,
  LoginFinalizationRequest,
  LoginRequest,
  LoginValidationResponse,
  MeResponse,
  ResetPasswordRequest,
} from "@/types/services/auth.type.ts";

const recoveryRequestConfig: CustomAxiosRequestConfig = {
  disableGlobalError: true,
};

class AuthService {
  async loginValidation(
    userData: LoginRequest,
  ): Promise<LoginValidationResponse> {
    const response = await api.post<LoginValidationResponse>(
      "/auth/login",
      userData,
    );
    return response.data;
  }

  async loginFinalization(payload: LoginFinalizationRequest): Promise<void> {
    await api.post("/auth/login/finalize", payload);
  }

  async verifyLogin2faCode(code: string): Promise<void> {
    await api.post("/auth/login/2fa/verify", { code });
  }

  async resendLogin2faCode(): Promise<void> {
    await api.post("/auth/login/2fa/resend");
  }

  async me(): Promise<MeResponse> {
    const response = await api.get<MeResponse>("/auth/me");
    return response.data;
  }

  async logout(): Promise<void> {
    await api.post("/auth/logout");
  }

  async initializePassword(payload: InitializePasswordRequest): Promise<void> {
    await api.post("/initialization-password", payload, recoveryRequestConfig);
  }

  async resetPassword(payload: ResetPasswordRequest): Promise<void> {
    await api.post("/reset-password", payload, recoveryRequestConfig);
  }

  async forgotPassword(payload: ForgotPasswordRequest): Promise<void> {
    await api.post("/forgot-password", payload, recoveryRequestConfig);
  }
}

export default new AuthService();
